module.exports = __webpack_public_path__ + "img/logo-Ticker.b5e3ad3d.png";